import type { SectionProps } from './types'

export function NotificationSection({ draft, setDraft }: SectionProps) {
  // メールダイジェストはバックエンド未実装（ハンドラ・メーラーとも無し）。
  // 「ON にできるのに一通も届かない」状態を避けるため準備中表示にする（判断D-3・fix-plan 5-2。
  // 実装は PLAN.md Phase 2 へ。設定値 notification.digest は保持したまま — 実装時にそのまま使える）
  void draft; void setDraft
  return (
    <div className="gm-card p-4 md:p-5">
      <p className="font-bold">承認待ちの通知</p>
      <p className="mt-1 text-sm text-ink-muted">生成された投稿が承認待ちになったときの知らせ方です。</p>
      <div className="mt-3 space-y-2 text-sm text-ink-muted">
        <p><span className="gm-chip gm-chip-neutral mr-2">準備中</span>メールダイジェスト通知は準備中です（Phase 2 で提供予定）。</p>
        <p>それまでは承認キュー画面でご確認ください（生成完了は自動で表示されます）。</p>
      </div>
    </div>
  )
}
